import { LOADING, PLATFORM_CONFIGURATION, REVIEWS } from "../actionType/reputationManagerType";

const initialState = {
  loading: true,
  reviews: null,
  platformConfiguration: null,
};

const ReputationMangerReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOADING:
      return { ...state, loading: payload };
    case REVIEWS:
      return { ...state, reviews: payload };
    case PLATFORM_CONFIGURATION:
      return { ...state, platformConfiguration: payload };
    default:
        return state;
  }
};

export default ReputationMangerReducer;
